import { Chip } from "@mui/material"

const STATUS_CONFIG = {
    resolved: { label: "Resolved", sx: { bgcolor: "rgba(0,171,85,0.14)", color: "text.primary" } },
    partially_resolved: { label: "Partial", sx: { bgcolor: "rgba(255,171,0,0.16)", color: "text.primary" } },
    unresolved_schedule: { label: "Unresolved", sx: { bgcolor: "rgba(255,72,66,0.12)", color: "text.primary" } },
}

export function ProjectBridgeMappingStatusChip({ status }) {
    const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.unresolved_schedule
    return <Chip label={config.label} size="small" sx={config.sx} />
}
